import React from 'react'
import './index.less'

export default class extends React.Component {
  state = {
    toastStatus: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }


  hideRule = async (status) => {

    let id = this.props.id


    if (this.state.toastStatus == true) {
      return
    }

    this.setState({
      toastStatus: status
    })

    document.getElementById(`toast${id}`).setAttribute("class", "toast block toastHide")

    if (status == true) {
      setTimeout(() => {
        this.setState({
          toastStatus: false
        })

        document.getElementById(`toast${id}`).setAttribute("class", "toast hide")
      }, 3000)
    }
    
  }

  render() {
    let { language, lang, toastContent, id } = this.props
    return (
      <div id={`toast${id}`} className={`toast hide`} onClick={this.hideRule.bind(this, false)}>
        <span className="toastContent">
          {toastContent}
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/Toast/index.js